/**
 * pd-icon-brands — Tree-shakeable Social Media & Brand SVG Icons
 *
 * Usage:
 * ```typescript
 * import { linkedinIcon, githubIcon } from "@progressive-development/pd-icon-brands";
 *
 * // In Lit template
 * html`<a href="https://linkedin.com/...">${linkedinIcon}</a>`
 * ```
 *
 * Each icon is a Lit `SVGTemplateResult` (24x24 viewBox, `fill="currentColor"`).
 * Size and color are controlled by the parent element via `width`, `height`, and `color`.
 *
 * @packageDocumentation
 */

// Social Networks
export { linkedinIcon } from "./icons/linkedin.js";
export { githubIcon } from "./icons/github.js";
export { xTwitterIcon } from "./icons/x-twitter.js";
export { instagramIcon } from "./icons/instagram.js";
export { facebookIcon } from "./icons/facebook.js";
export { youtubeIcon } from "./icons/youtube.js";
export { tiktokIcon } from "./icons/tiktok.js";
export { xingIcon } from "./icons/xing.js";

// Messaging
export { whatsappIcon } from "./icons/whatsapp.js";
export { telegramIcon } from "./icons/telegram.js";

// Professional / Dev
export { stackoverflowIcon } from "./icons/stackoverflow.js";
export { dribbbleIcon } from "./icons/dribbble.js";
export { behanceIcon } from "./icons/behance.js";

// Music / Streaming / DJ
export { twitchIcon } from "./icons/twitch.js";
export { soundcloudIcon } from "./icons/soundcloud.js";
export { mixcloudIcon } from "./icons/mixcloud.js";
export { spotifyIcon } from "./icons/spotify.js";
export { appleMusicIcon } from "./icons/apple-music.js";
export { deezerIcon } from "./icons/deezer.js";
export { bandcampIcon } from "./icons/bandcamp.js";
export { beatportIcon } from "./icons/beatport.js";
export { discogsIcon } from "./icons/discogs.js";

// Additional Social / Community
export { pinterestIcon } from "./icons/pinterest.js";
export { threadsIcon } from "./icons/threads.js";
export { blueskyIcon } from "./icons/bluesky.js";
export { snapchatIcon } from "./icons/snapchat.js";
export { discordIcon } from "./icons/discord.js";
export { redditIcon } from "./icons/reddit.js";
export { vimeoIcon } from "./icons/vimeo.js";
export { mastodonIcon } from "./icons/mastodon.js";
export { mediumIcon } from "./icons/medium.js";
export { patreonIcon } from "./icons/patreon.js";

// Default / Fallback
export { defaultBrandIcon } from "./icons/default-brand.js";

// Utility: Type & lookup map
export { brandIconMap, type BrandIconName } from "./brand-icon-map.js";
